export default "__VITE_ASSET__BiujCouK__"